import React from "react";
import { useApiClient } from "../../../shared/customHooks";
import { applicationTypeForm } from "../../../shared/formObjects/application/applicationTypeForm";
import { useApplicationContext } from "../context/applicationContext";
import { useGlobalContext } from "../../../shared/GlobalContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ApplicationTypeComponent({ disabled, data }: any) {
  const api = useApiClient("ApplicationType");
  const {
    id,
    application: { hasAppeal },
  } = useApplicationContext();
  const { accountInfo } = useGlobalContext();

  return (
    <BaseApplicationComponent
      formBody={applicationTypeForm}
      headerLabel="Application Category"
      editPath="applicationtype"
      apiClient={api}
      disabled={disabled}
      showEdit={accountInfo.isInternal && disabled && !hasAppeal}
      data={data}
      id={id}
    />
  );
}

export default ApplicationTypeComponent;
